import axios from 'axios';

//  const baseURL = 'http://127.0.0.1:5000/';
const baseURL = 'https://api-servicos-automacao.bairru.com.br/';

const apiAutomacao = axios.create({ baseURL });

export default apiAutomacao;